<template>
<form
  role="form"
  class="elr-form"
  @submit.prevent="update"
  id="update-user"
>
  <div class="elr-row">
      <div class="elr-col-half form-input-holder">
        <label for="first_name">First Name:</label>
        <input type="text" placeholder="First Name" id="first_name" name="first_name" v-model="formData.first_name">
      </div>
      <div class="elr-col-half form-input-holder">
        <label for="last_name">Last Name:</label>
        <input type="text" placeholder="Last Name" id="last_name" name="last_name" v-model="formData.last_name">
      </div>
  </div>
    <div class="elr-row">
      <div class="elr-col-full form-input-holder">
        <label for="email">Email Address:</label>
        <input type="email" placeholder="Email Address" id="email" name="email" v-model="formData.email">
      </div>
  </div>
  <div class="elr-row">
    <div class="elr-col-half form-input-holder">
      <label for="password">Password:</label>
      <input type="password" placeholder="Password" id="password" name="password" class="elr-password" v-model="formData.password">
    </div>
    <div class="elr-col-half form-input-holder">
      <label for="password_confirmation">Confirm Password:</label>
      <input type="password" placeholder="Confirm Password" id="password_confirmation" name="password_confirmation" v-model="formData.password_confirmation">
    </div>
  </div>
  <div class="elr-row">
    <div class="elr-col-full form-input-holder">
      <label for="country">Country:</label>
      <input type="text" placeholder="Country" id="country" name="country" v-model="formData.country">
    </div>
  </div>
  <div class="elr-row">
    <div class="elr-col-full form-input-holder" style="padding-top: 20px;">
      <button type="submit" class="elr-button elr-button-primary">Update Your Account</button>
    </div>
  </div>
</form>
</template>

<script>
export default {
  name: 'FormUserEdit',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      errors: [],
      formData: {
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        country: this.user.country,
        username: this.user.username,
        password: null,
        password_confirmation: null
      }
    };
  },
  methods: {
    resetForm() {
      this.formData = {
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        password: null,
        password_confirmation: null,
        country: this.user.country,
        username: this.user.username
      };
    },
    update() {
      this.$emit('updatedUser', {
        item: this.formData
      });
      // this.resetForm();
    }
  }
};
</script>
